module.exports = __webpack_public_path__ + "img/doctor_black.61833c58.svg";